module.exports = function (getSchemeUrl) {
	'use strict';

	function createLink (url) {
		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.type = 'text/css';
		link.href = url;
		link.setAttribute('colorscheme', 'colorscheme');

		return link;
	}

	return function (colorscheme) {
		var head = document.getElementsByTagName('head')[0];
		var currentColorscheme = head.querySelector('[colorscheme]');
		var colorschemeUrl = getSchemeUrl(colorscheme);

		if (currentColorscheme) {
			if (currentColorscheme.href === colorschemeUrl) return false;
			
			if (currentColorscheme.nextSibling) {
				currentColorscheme.parentNode.insertBefore(createLink(colorschemeUrl), currentColorscheme.nextSibling);
				
				setTimeout(function () {
					currentColorscheme.parentNode.removeChild(currentColorscheme);
				}, 10);
			} else {
				currentColorscheme.parentNode.replaceChild(createLink(colorschemeUrl), currentColorscheme);
			}
		} else {
			head.appendChild(createLink(colorschemeUrl));
		}
	}
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/utils/switch-colorscheme.js
// module id = 1132
// module chunks = 4